module.exports = __webpack_public_path__ + "components/forecast-table/tooltips/static/snowfall-7c236faf0b04de613458b2b1985d5a8f.jpg";